import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { RECHECK_APPROVED, RECHECK_REJECTED, RECHECK_REQUESTED } from '../../utils/variables';

const Image = props => {
  return (
    <div
      className={classNames('img-container', props.className, {
        'fix-height': props.hasFixHeight,
        'full-width': props.imgHasFullWidth,
        'with-background': props.hasBackground,
      })}
      onClick={props.onClick}
    >
      <img
        className={classNames('image', {
          'img-hover': props.hasHoverEffect,
          'full-width': props.imgHasFullWidth,
        })}
        src={props.src}
      />
      {props.coloredRecheckOverlay === RECHECK_APPROVED  && (
        <div
          className={classNames('protection-overlay protection-overlay_approved-recheck', {
            'protection-overlay-hover protection-overlay-hover_approved-recheck': props.hasHoverEffect ,
          })}
        />
      )}
      {props.coloredRecheckOverlay === RECHECK_REJECTED && (
        <div
          className={classNames('protection-overlay protection-overlay_rejected-recheck', {
            'protection-overlay-hover protection-overlay-hover_rejected-recheck': props.hasHoverEffect,
          })}
        />
      )}
      {props.hasProtectionOverlay && (!props.coloredRecheckOverlay || props.coloredRecheckOverlay === RECHECK_REQUESTED) && (
        <div
          className={classNames('protection-overlay', {
            'protection-overlay-hover': props.hasHoverEffect,
          })}
        />
      )}
      {props.bottomLeftElement && !props.coloredRecheckOverlay && (
        <div className="img-element bottom-left">{props.bottomLeftElement}</div>
      )}
      {props.bottomLeftElement && props.coloredRecheckOverlay && (
        <div className="img-recheck-info-element">{props.bottomLeftElement}</div>
      )}
      {props.topRightElement && (
        <div className="img-element top-right">{props.topRightElement}</div>
      )}
    </div>
  );
};

Image.defaultProps = {
  hasBackground: true,
  hasHoverEffect: true,
  hasFixHeight: false,
  hasProtectionOverlay: true,
  imgHasFullWidth: false,
  coloredRecheckOverlay: null,
};

Image.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  hasBackground: PropTypes.bool,
  hasHoverEffect: PropTypes.bool,
  hasFixHeight: PropTypes.bool,
  hasProtectionOverlay: PropTypes.bool,
  imgHasFullWidth: PropTypes.bool,
  bottomLeftElement: PropTypes.node,
  topRightElement: PropTypes.node,
  onClick: PropTypes.func,
  coloredRecheckOverlay: PropTypes.string,
};

export default Image;
